// extracted by mini-css-extract-plugin
export var o_carrusel2 = "carrusel2-module--o_carrusel2--7d3b5";
export var o_carrusel2__bg = "carrusel2-module--o_carrusel2__bg--aac41";
export var o_carrusel2__bg2 = "carrusel2-module--o_carrusel2__bg2--17b71";
export var o_carrusel2__body = "carrusel2-module--o_carrusel2__body--f9c2a";
export var o_carrusel2__h2 = "carrusel2-module--o_carrusel2__h2--4269d";
export var o_carrusel2__intro = "carrusel2-module--o_carrusel2__intro--73114";
export var o_carrusel2__main = "carrusel2-module--o_carrusel2__main--f7227";